module.exports = __webpack_public_path__ + "static/img/example_item_pathways.e45b16ae.png";